import type { ReactElement } from 'react';
import { useAuthStore, useMeQuery } from '@/entities/user';

const EYEBROW_CLASS =
  'text-[11px] leading-none font-semibold tracking-[0.18em] text-muted-foreground uppercase';

/**
 * 마이페이지 머리 — 기획전·포트폴리오와 같은 큰 영문 제목("My Page")과 한 줄 인사.
 * 이름은 로그인 세션(auth store)의 값을, 이메일은 users.me(이메일 변경 뒤 최신값)를 쓰고 불러오는 동안엔 세션 값으로 대신한다.
 */
export const MyPageHeader = (): ReactElement => {
  const user = useAuthStore((state) => state.user);
  const me = useMeQuery();
  const email = me.data?.email ?? user?.email;

  return (
    <header className="flex flex-col gap-8 border-b border-foreground/10 pb-10 sm:flex-row sm:items-end sm:justify-between sm:pb-12">
      <div className="flex flex-col gap-4">
        {/* 보이는 제목은 영문, 보조기기에는 한국어 화면 이름을 읽힌다. */}
        <h1 className="text-[clamp(2.5rem,5vw,4.5rem)] leading-none font-bold tracking-[-0.03em]">
          <span aria-hidden>My Page</span>
          <span className="sr-only">마이페이지</span>
        </h1>
        <p className="text-[15px] text-muted-foreground sm:text-base">
          {user ? (
            <>
              <strong className="font-semibold text-foreground">{user.name}</strong>님,
              견적·디자인·계정을 한곳에서 관리하세요.
            </>
          ) : (
            '견적·디자인·계정을 한곳에서 관리하세요.'
          )}
        </p>
      </div>

      {user ? (
        <dl className="flex flex-col gap-2 text-sm sm:items-end sm:text-right">
          <dt className={EYEBROW_CLASS}>Account</dt>
          <dd className="wrap-anywhere">{email}</dd>
        </dl>
      ) : null}
    </header>
  );
};
